export default "__VITE_ASSET__DP0R2lCO__"